

export const venueCapacity = (venue) => {
    // Check if venue and VenueSpaces exist
    if (!venue || !venue.VenueSpaces || !Array.isArray(venue.VenueSpaces)) {
        return {
            seated: 0,
            standing: 0
        };
    }
    
    // Add up all of the seatedCapacity and standingCapacity from VenueSpaces
    const totalSeatedCapacity = venue.VenueSpaces.reduce((sum, space) => {
        return sum + (space.seatedCapacity || 0);
    }, 0);
    
    const totalStandingCapacity = venue.VenueSpaces.reduce((sum, space) => {
        return sum + (space.standingCapacity || 0);
    }, 0);
    
    return {
        seated: totalSeatedCapacity,
        standing: totalStandingCapacity
    };
}